type Props = {
  children: any;
};

export function NoWrap({ children }: Props) {
  return <span style={{ whiteSpace: "nowrap" }}>{children}</span>;
}
